import { CURRENCY_SYMBOLS } from "../utils/currencymap.js";
import { errorMsg, msgData } from "./utils.js";
import { formatDate } from "../utils/date.js";

export async function formatCurrency(value, currencyCode) {
  const { formatNumber, parseNumber } = await import("widgets/inputs");
  if (!value) return null;
  const formattedCurrencyCd = currencyCode.toUpperCase();
  currencyCode = Object.keys(CURRENCY_SYMBOLS).includes(formattedCurrencyCd)
    ? formattedCurrencyCd
    : "";
  value = parseNumber(value);
  return `${formatNumber(value)} ${currencyCode}`.trim();
}

export const formatToKfDate = async (data, isDateTime) => {
  try {
    const timestamp = Date.parse(data.date);
    if (isNaN(timestamp)) {
      return errorMsg(data, { message: "Invalid Date Format" });
    }
    const date = new Date(timestamp);
    const formattedDate = formatDate(date, isDateTime);
    return msgData(data, {
      formattedDate
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const formatToKfNumber = async (data) => {
  const { formatNumber, parseNumber } = await import("widgets/inputs");
  try {
    let parsedNumber = parseNumber(data.value);
    let formattedNumber = formatNumber(parsedNumber);
    return msgData(data, {
      formattedNumber
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const formatToKfCurrency = (data) => {
  try {
    const { value, currencyCode } = data;
    const formattedCurrency = formatCurrency(value, currencyCode);
    return msgData(data, {
      formattedCurrency
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};

export const formatToKfBoolean = (data) => {
  try {
    const formattedValue =
      data.value === "1" ||
      data.value.toLowerCase() === "true" ||
      data.value.toLowerCase() === "yes";
    return msgData(data, {
      formattedValue
    });
  } catch (e) {
    return errorMsg(data, e);
  }
};
